import $ from 'jquery';
import _ from 'underscore';
import UI from 'root/ui';
import Cache from 'root/cache';
import Util from 'root/module/util';
import Router from 'root/router';
import Modals from 'root/modals';
import Model_Feedback from 'model/feedback';
import View from 'view/base';
import View_Feedback_Preview from 'view/portal/feedback_preview';
import View_New_Comment from 'view/portal/new_comment';
import View_Comment from 'view/portal/comment';
import {showAutoReplyMessage, deleteComment} from 'service/feedback';

export default View.extend({
    className: 'overlay overlay-sidebar overlay-portal',

    views: {
        preview: {},
        new_comment: {},
        thread: {}
    },

    active_tab: 'comment',
    voters: null,

    events: {
        'click'                          : 'onClick',
        'click .close'                   : 'onClose',
        'click .admin-share'             : 'onShare',
        'click .admin-unapprove'         : 'onUnapprove',
        'click .admin-delete'            : 'onDelete',
        'click .admin-categorize li'     : 'onCategorize',
        'click .admin-status li'         : 'onChangeStatus',
        'click .admin-pin'               : 'onPin',
        'click .admin-unpin'             : 'onUnpin',
        'click .region-tab-header button': 'onTabToggle',
    },

    dom_handlers: {
        onClick: function(e) {
            if ($(e.target).hasClass('overlay-sidebar')) {
                this.trigger('close');
            }
        },

        onClose: function(e) {
            this.trigger('close');
        },

        onShare: function(e) {
            Modals.shareFeedback(this.model, true);
        },

        onUnapprove: function(e) {
            Modals.unapproveFeatureRequest(this.model, function() {
                Cache.feedback.remove(this.model);
                this.trigger('close');
            }.bind(this));
        },

        onDelete: function(e) {
            Modals.deleteFeedback([this.model.id], false, false, function() {
                this.trigger('close');
            }.bind(this));
        },

        onCategorize: function(e) {
            e.stopPropagation();

            $(e.currentTarget).toggleClass('selected');

            var category_name = $(e.currentTarget).text();
            var categories    = this.model.get('category') ? this.model.get('category').split(',') : [];
            var index = categories.indexOf(category_name);
            var action;

            if (index === -1) {
                action = 'feedback/addCategory';
                categories.push(category_name);
            } else {
                action = 'feedback/deleteCategory';
                categories.splice(index, 1);
            }

            Cache.app.request({
                action: action,
                data: {
                    feedback_ids : [this.model.id],
                    category_name: category_name
                },

                success: (response) => {
                    this.model.set('category', categories.join(','));
                }
            });
        },

        onChangeStatus: function(e) {
            var workflow_id = parseInt($(e.currentTarget).data('val'), 10);
            var type = $(e.currentTarget).data('type');
            this.$el.find('.admin-status li.selected').removeClass('selected');
            $(e.currentTarget).addClass('selected');

            const is_resolved = Cache.workflow.get(workflow_id).isResolved();
            Cache.app.request({
                action: 'feedback/setWorkflow',
                context: this,
                data: {
                    ids: [this.model.id],
                    workflow: workflow_id,
                    send_autoreply: is_resolved && type === 'resolve-reply'
                },
                success: function(result) {
                    if (!result || !result.autoreply_comments || result.autoreply_comments.length === 0) {
                        return;
                    }
                    const autoreply_comments = result.autoreply_comments;
                    const autoreply_comment_ids = autoreply_comments.map((comment) => comment.id);
                    showAutoReplyMessage(() => {
                        deleteComment(autoreply_comment_ids);
                    });

                    // Get all the comments
                    // Do something with the comments
                    autoreply_comments.forEach((autoreply_comment) => {
                        if (!Cache.feedback_comment.get(autoreply_comment.id)) {
                            Cache.feedback_comment.add(autoreply_comment);
                        }
                    });
                }
            });

            UI.success('Status updated');
            this.model.set({workflow: workflow_id});
        },

        onPin: function(e) {
            this.$el.find('.admin-unpin').show();
            this.$el.find('.admin-pin').hide();

            this.model.set('is_pinned', true);

            Cache.app.request({
                action: 'feedback/pin',
                context: this,
                data: {
                    id: this.model.id,
                    is_pinned: true
                },
                success: function() {
                    UI.success('Feedback pinned');
                }
            });
        },

        onUnpin: function(e) {
            this.$el.find('.admin-unpin').hide();
            this.$el.find('.admin-pin').show();

            this.model.set('is_pinned', false);

            Cache.app.request({
                action: 'feedback/pin',
                context: this,
                data: {
                    id: this.model.id,
                    is_pinned: false
                },
                success: function() {
                    UI.success('Feedback unpinned');
                }
            });
        },

        onTabToggle(e) {
            var value = $(e.currentTarget).data('value');

            this.$el.find('.region-tab-header button').removeClass('active');
            $(e.currentTarget).addClass('active');


            this.$el.find('.region-tab-item').removeClass('active').filter('[data-value="' + value + '"]').addClass('active');

            if (value === 'voter' && this.voters === null) {
                this.getVoters();
            }
        },
    },

    event_handlers: {
        onCommentAdd: function(model) {
            if (model.get('reply_comment_id') ||
                model.get('screen_number') ||
                model.get('video_time')) {

                return;
            }

            if (!this.model) {
                return;
            }

            if (model.get('feedback_id') !== this.model.id) {
                return;
            }

            this.$el.find('.comment-count').text(this.getCommentCount());

            this.views.thread['_' + model.id] = new View_Comment({
                model: model
            });

            this.views.thread['_' + model.id].render().$el.appendTo(this.$el.find('.region-comments'));

            // scroll to bottom
            var scroll_container = this.$el.find('.feedback-display');

            if (scroll_container.length) {
                scroll_container.scrollTop(scroll_container.get(0).scrollHeight);
            }
        },

        onCommentRemove: function(model) {
            this.$el.find('.comment-count').text(this.getCommentCount());

            if (typeof this.views.thread['_' + model.id] !== 'undefined') {
                this.views.thread['_' + model.id].remove();
                delete this.views.thread['_' + model.id];
            }
        }
    },

    initialize: function(options) {
        this.feedback_id = options.feedback_id;
        this.embed       = options.embed;

        if (Cache.feedback.get(this.feedback_id)) {
            this.model = Cache.feedback.get(this.feedback_id);
            this.createViews();
        }

        this.listenTo(Cache.feedback_comment, 'add',    this.event_handlers.onCommentAdd);
        this.listenTo(Cache.feedback_comment, 'remove', this.event_handlers.onCommentRemove);
        this.listenTo(this.model, 'change:workflow', this.renderAdminActions);
    },

    canComment: function() {
        return Cache.real_user_id || this.model.get('allow_public_comment');
    },

    createViews: function() {
        this.views.preview = new View_Feedback_Preview({
            model: this.model,
            mode: 'desc'
        });

        if (this.canComment()) {
            this.views.new_comment = new View_New_Comment({
                embed: this.embed,
                feedback_id: this.feedback_id
            });
        }

        Cache.feedback_comment.where({feedback_id: this.model.id, reply_comment_id: 0}).forEach(function(model) {
            this.views.thread['_' + model.id] = new View_Comment({
                model: model,
                embed: this.embed
            });
        }.bind(this));
    },

    loadFeedback: function() {
        this.xhr = Cache.app.request({
            action: 'portal/loadFeedback',
            context: this,
            data: {
                page_size   : 1,
                feedback_id : this.feedback_id
            },
            success: function(response) {
                if (response.feedback.length) {
                    this.model = new Model_Feedback(response.feedback[0]);

                    Cache.feedback_comment.add(response.feedback_comment);
                    Cache.feedback_screenshot.add(response.feedback_screenshot);

                    // don't add feedback to the collection
                    // so that it won't appear in the main list on the homepage
                    this.createViews();
                    this.render();
                } else {
                    this.no_post = true;
                    this.render();
                }
            }
        });
    },

    getCommentCount: function() {
        if (!this.model) {
            return '';
        }

        var total_comments = this.model.getTotalComments(true);
        return total_comments + ' Comment' + (total_comments === 1 ? '' : 's');
    },

    getVoters: function() {
        Cache.app.request({
            action: 'portal/loadFeedbackVoterInfo',
            data: {
                feedback_id: this.model.id,
            },

            success: (response) => {
                this.voters = response;

                this.renderVoters();
            }
        });
    },

    renderVoters: function () {
        var content = '';

        if (this.voters.length) {
            this.voters.forEach(function (voter) {
                content += '<li class="voter-item">' +
                                '<div class="user-img-32" style="background-image:url(\'' + (voter.avatar || Util.gravatar(voter.email, 32, voter.name)) + '\');"></div>' +
                                '<div class="voter-info">' +
                                    '<div class="voter-name">' + (voter.name ? voter.name : 'Deleted User') +
                                        (Cache.app.isAdmin() || Cache.app.isCollaborator() ?
                                        voter.is_admin ?
                                        '<span class="badge-small badge-borderless badge-primary-invert">Admin</span>' : '' : '') +
                                    '</div>' +
                                    (Cache.app.isAdmin() || Cache.app.isCollaborator() ? '<div class="voter-email">' + voter.email + '</div>' : '') +
                                '</div>' +
                            '</li>';
            });
        } else {
            content += '<p class="text-info italic">No one has voted on this idea yet.</p>';
        }

        this.$el.find('.voter-list').html(content);
    },

    scrollToThread: function(comment_id) {
        var view = this.views.thread['_' + comment_id];

        if (!view) {
            return;
        }

        view.showReplies();

        this.$el.find('.feedback-display').scrollTop(view.$el.offset().top + view.$el.height());
    },

    onRender: function() {
        if (!this.model) {
            return;
        }

        var highlight_comment_id = parseInt(Router.getQueryString('c'), 10);

        _.each(this.views.thread, function(view) {
            if (view.model.id === highlight_comment_id) {
                // wait for view to be added to the doc
                setTimeout(function() {
                    this.scrollToThread(view.model.id);
                }.bind(this), 100);
            }
        }, this);
    },

    renderAdminActions: function() {
        if (!this.model) {
            return;
        }

        if (!Cache.real_user_id || !Cache.app.isAdmin()) {
            return;
        }

        const feedback_autoreply = Cache.feedback_autoreply.findWhere({project_id: this.model.get('project_id')});
        var is_autoreply_enabled = feedback_autoreply?.isEnabled(this.model.get('feedback_type'));

        var status_options = '';
        Cache.portal_status.each(function(status, count) {
            if (count > 0) {
                status_options += '<li class="separator"></li>';
            }

            status_options += '<li class="dropdown-title">' + status.escape('status_name') + '</li>';

            Cache.workflow.where({portal_status_id: status.id}).forEach(function(workflow) {
                const is_resolved = Cache.workflow.get(workflow.id).isResolved();
                status_options += '<li data-val="' + workflow.id + '"' + (workflow.id === this.model.get('workflow') ? ' class="selected"' : '') + '>' +
                                        '<span class="workflow-option-colour" style="background-color:' + workflow.get('colour') + ';"></span>' +
                                        workflow.escape('name') +
                                    '</li>';

                if (is_resolved && is_autoreply_enabled && workflow.id !== this.model.get('workflow')) {
                    status_options += '<li class="notrim" data-val="' + workflow.id + '" data-type="resolve-reply">' +
                        '<span class="workflow-option-colour" style="background-color:' + workflow.get('colour') + ';"></span>' +
                        workflow.escape('name') + ' & Auto-reply' +
                    '</li>';
                }
            }.bind(this));
        }, this);

        var category_options = '';
        Cache.feedback_category.each(function(option) {
            if (Cache.portal.at(0).get('categories').split(',').indexOf(option.get('name')) === -1) {
                return;
            }

            var categories = this.model.get('category') ? this.model.get('category').split(',') : [];

            var is_selected = categories.indexOf(option.get('name')) !== -1;

            category_options +=
            '<li class="tag-category' + (is_selected ? ' selected' : '') + '">' +
                option.escape('name') +
            '</li>';
        }, this);

        var content =
        '<span>Admin</span>' +

        '<div class="action"><button type="button" class="admin-unapprove tooltip" data-title="Unpublish"><i class="far fa-eye-slash"></i></button></div>' +

        '<div class="button-dropdown button-dropdown-top-left">' +
            '<button type="button" class="tooltip" data-title="Status"><i class="far fa-network-wired"></i></button>' +
            '<div>' +
                '<ul class="admin-status dropdown dropdown-select dropdown-long">' + status_options + '</ul>' +
            '</div>' +
        '</div>' +

        '<div class="button-dropdown button-dropdown-top-left">' +
            '<button type="button" class="tooltip" data-title="Categorize"><i class="far fa-tags"></i></button>' +
            '<div>' +
                '<ul class="admin-categorize dropdown dropdown-select">' + category_options + '</ul>' +
            '</div>' +
        '</div>' +

        '<div class="action"><button type="button" class="admin-unpin tooltip active" data-title="Unpin"' + (this.model.get('is_pinned') ? '' : ' style="display:none;"') + '><i class="far fa-thumbtack"></i></button></div>' +
        '<div class="action"><button type="button" class="admin-pin tooltip" data-title="Pin"' + (!this.model.get('is_pinned') ? '' : ' style="display:none;"') + '><i class="far fa-thumbtack"></i></button></div>' +


        '<div class="action"><button type="button" class="admin-delete tooltip" data-title="Delete"><i class="far fa-trash-alt"></i></button></div>' +
        '<div class="action"><button type="button" class="admin-share tooltip" data-title="Share Settings"><i class="far fa-share"></i></button></div>';

        this.$el.find('.admin-actions').html(content);
    },

    render: function() {
        var content = '';

        if (this.model) {
            var screenshots = [];
            var screenshots_container = '';

            _.each(this.views.thread, function(view) {
                if (view.model.get('screen_number') > 0) {
                    if (screenshots.indexOf(view.model.get('screenshot_num')) === -1) {
                        screenshots.push(view.model.get('screenshot_num'));
                    }
                }
            });

            if (screenshots.length > 1) {
                screenshots.forEach(function(num) {
                    screenshots_container += '<div class="region-screenshot"><span>Screenshot ' + (num + 1) + '</span></div>';
                });
            }

            content += '<div class="portal-feedback-details">' +
                            (Cache.real_user_id && Cache.app.isAdmin() ?
                            '<div class="admin-actions"></div>' : '' ) +

                            '<button type="button" class="close btn-close">' +
                            (this.embed === 'widget' ?
                            '<i class="fa-regular fa-chevron-left"></i>' : '<i class="fa-regular fa-xmark"></i>') +
                            '</button>' +

                            '<div class="feedback-display">' +
                                '<div class="region-preview"></div>' +
                                '<div class="region-new-comment"></div>' +
                                '<div class="region-tab-header">' +
                                    '<button type="button" class="region-comment-header' + (this.active_tab === 'comment' ? ' active' : '') + '" data-value="comment">' + this.getCommentCount() + '</button>' +
                                    '<button type="button" class="region-voter-header' + (this.active_tab === 'voter' ? ' active' : '') + '" data-value="voter">Voters</button>' +
                                '</div>' +
                                '<div class="region-tab-body">' +
                                    '<div class="region-tab-item' + (this.active_tab === 'comment' ? ' active' : '') +'" data-value="comment">' +
                                        (this.canComment()
                                            ? (this.model.get('allow_public_comment') ? '' : '<div class="comment-off">(Public commenting has been turned off)</div>')
                                            : '<div class="comment-off">(Commenting has been turned off)</div>') +
                                        '<div class="region-comments">' +
                                            (screenshots_container ? '<div class="region-screenshot-container">' + screenshots_container + '</div>' : '') +
                                        '</div>' +
                                    '</div>' +
                                    '<div class="region-tab-item' + (this.active_tab === 'voter' ? ' active' : '') +'" data-value="voter">' +
                                        '<ul class="voter-list"></ul>' +
                                    '</div>' +
                                '</div>' +
                            '</div>' +
                        '</div>';
        } else if (this.no_post) {
            content += '<div class="portal-feedback-details">' +
                            '<button type="button" class="close btn-close"><i class="fa-regular fa-xmark"></i></button>' +
                            '<div class="no-post">' +
                                '<div><i class="far fa-eye-slash"></i></div>' +
                                '<h2>Oops</h2>' +
                                '<div class="text-info">The post couldn\'t be found</div>' +
                            '</div>' +
                        '</div>';
        } else {
            content += '<div class="portal-feedback-details">' +
                            '<button type="button" class="close btn-close"><i class="fa-regular fa-xmark"></i></button>' +
                            '<div class="padding-left-42 padding-right-42">' +
                                '<div class="loader-placeholder-regular margin-bottom-16 float-left" style="width:60px;height:60px;"></div>' +
                                '<div class="margin-left-80">' +
                                    '<div class="loader-placeholder-medium margin-bottom-16" style="width:320px;"></div>' +
                                    '<div class="loader-placeholder-medium margin-bottom-16"></div>' +
                                    '<div class="loader-placeholder-medium margin-bottom-16"></div>' +
                                    '<div class="loader-placeholder-medium margin-bottom-16"></div>' +
                                    '<div class="loader-placeholder" style="display:inline-block;width:80px;margin-right:8px;"></div>' +
                                    '<div class="loader-placeholder" style="display:inline-block;width:80px;"></div>' +
                                '</div>' +
                            '</div>' +
                        '</div>';
        }

        this.$el.html(content);

        if (this.model) {
            this.views.preview.render().$el.appendTo(this.$el.find('.region-preview'));

            if (this.views.new_comment instanceof View_New_Comment) {
                this.views.new_comment.render().$el.appendTo(this.$el.find('.region-new-comment'));
            }

            _.each(this.views.thread, function(view) {
                var container;

                if (view.model.get('screen_number') > 0 && screenshots.length > 1) {
                    container = this.$el.find('.region-screenshot').eq(view.model.get('screenshot_num'));
                } else {
                    container = this.$el.find('.region-comments');
                }

                view.render().$el.appendTo(container);
            }, this);
        } else if (!this.no_post) {
            this.$el.addClass('loaded');
            this.loadFeedback();
        }

        this.renderAdminActions();
        this.onRender();

        return this;
    }
});